<template>
	<!-- <div class="back">
		<div>
			<img src="../assets/starsystem_type2.png" alt="nextjourney" class="imagetitle" />
		</div>
		<div class="button-container">
			<button class="btnhd" @click="sol()">Digital Innovationだからできること</button>
			<button class="btnhd" @click="customer()">お客様事例</button>
			<button class="btnhd" @click="shohin()">商品紹介</button>
			<button class="btnhd" @click="otoiawase()">お問い合わせ</button>
		</div>
		{{ Shohin }}
	</div> -->

	<div class="hamburger">
		<div class="logo"><img src="../assets/starsystem_type2.png" alt="nextjourney" class="imagetitle" /></div>
		<p class="btn-gNav" :class="{ 'open': isOpen }" @click="toggleMenu">
			<span></span>
			<span></span>
			<span></span>
		</p>
		<nav class="gNav">
			<ul class="gNav-menu">
				<li><button class="btnhd" @click="sol()">Digital Innovationだからできること</button></li>
				<li><button class="btnhd" @click="customer()">お客様事例</button></li>
				<li><button class="btnhd" @click="shohin()">商品紹介</button></li>
				<!-- <li><button class="btnhd" @click="shohin()">商品紹介</button></li> -->
				<li><button class="btnhd" @click="otoiawase()">お問い合わせ</button></li>
			</ul>
		</nav>
	</div>
</template>

<script>
// import bootstrap from 'bootstrap';

// import { ref } from 'vue';

export default {
	// eslint-disable-next-line
	/* eslint-disable */
	name: "headerParts",
	props: {
		Shohin: {
			type: String,
			default: "商品",
		},
	},
	data() {
		return {
			isOpen: false
		}
	},
	methods: {
		sol() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			})
			this.isOpen = !this.isOpen;
			$('.gNav').toggleClass('open');
			// this.$router.push({ hash: '/test' }).catch(() => { });
		},
		customer() {
			window.location.href = "https://star-system.jp/wp-content/uploads/2024/06/kintone.pdf";
		},
		shohin() {
			window.location.href = "https://digital-innovation-lab-nagoya.web.app/nextjourney";
		},
		otoiawase() {
			this.$router.push("/tos").catch(() => { });
		},
		open() {
			// Bootstrap のオフキャンバスを初期化
			const offcanvasElements = document.querySelectorAll('.offcanvas')
			offcanvasElements.forEach(element => {
				new bootstrap.Offcanvas(element)
			})
		},
		toggleMenu() {
			this.isOpen = !this.isOpen;
			$('.gNav').toggleClass('open');
		}
	},
}
</script>

<style scoped>
.back {
	position: fixed;
	width: 100%;
	height: 10vh;
	background-color: #0D263D;
	z-index: 100;
	display: flex;
	justify-content: space-between;
	align-items: center;
	/* 追加：垂直方向の中央揃え */
}

.imagetitle {
	width: 150px;
	margin: 0;
	margin-left: 20%;
	/* 変更：マージンをリセット */
}

.btnhd {
	display: flex;
	justify-content: center;
	position: relative;
	width: 200px;
	margin: 0 auto;
	padding: .9em 2em;
	border: none;
	border-bottom: 2px solid #F6A8B5;
	background-color: transparent;
	color: #e6edf3;
	font-weight: 600;
	font-size: 0.7em;
	top: 30%;
}

.btnhd::after {
	position: absolute;
	bottom: -3px;
	left: 0;
	transform: scaleX(0);
	transform-origin: center left;
	width: 100%;
	height: 2px;
	background-color: #F1C40F;
	content: '';
	transition: transform .3s ease;
}

.btnhd:hover::after {
	transform: scaleX(1);
}

/* 追加：ボタンコンテナのスタイル */
.button-container {
	display: flex;
	align-items: center;
	gap: 1rem;
	/* ボタン間の間隔 */
}

/**20241028
 */
ol,
ul {
	list-style: none;
	list-style-type: none;
}

a {
	text-decoration: none;
	color: #ffffff;
	font-size: 20px;
	letter-spacing: 0.1em;
}

.hamburger {
	/* margin: 20px auto 0; */
	width: 100%;
	height: 13vh;
	display: flex;
	justify-content: space-between;
	background-color: #0D263D;
	position: fixed;
	z-index: 10;
	/*fixedで固定*/
}

.logo {
	/* font-size: 40px;
	font-weight: 700; */
	/* width: 40%; */
	margin-top: 2%;
	/* margin-right: 50%; */
}

.hamburger .btn-gNav {
	position: fixed;
	top: 1%;
	right: 7%;
	width: 30px;
	height: 24px;
	z-index: 12;
	box-sizing: border-box;
	cursor: pointer;
	-webkit-transition: all 400ms;
	transition: all 400ms;
}

.hamburger .btn-gNav span {
	position: absolute;
	width: 100%;
	height: 4px;
	background: #ffffff;
	border-radius: 10px;
	-webkit-transition: all 400ms;
	transition: all 400ms;
}

.hamburger .btn-gNav span:nth-child(1) {
	top: 0;
}

.hamburger .btn-gNav span:nth-child(2) {
	top: 10px;
}

.hamburger .btn-gNav span:nth-child(3) {
	top: 20px;
}

.hamburger .btn-gNav.open span:nth-child(1) {
	background: #ffffff;
	top: 6px;
	-webkit-transform: rotate(-45deg);
	-moz-transform: rotate(-45deg);
	transform: rotate(-45deg);
}

.hamburger .btn-gNav.open span:nth-child(2),
.hamburger .btn-gNav.open span:nth-child(3) {
	top: 6px;
	background: #ffffff;
	-webkit-transform: rotate(45deg);
	-moz-transform: rotate(45deg);
	transform: rotate(45deg);
}


.btn-gNav {
	display: none;
}

.gNav .gNav-menu {
	display: flex;
	justify-content: space-between;
}

.gNav .gNav-menu li {
	margin: 0 auto;
	padding: 0 5px;
}

@media screen and (max-width: 600px) {
	.btn-gNav {
		display: block;
	}

	.hamburger {
		top: 0;
		height: 10vh;
	}

	.gNav {
		position: fixed;
		top: 0;
		right: -100%;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		font-size: 16px;
		box-sizing: border-box;
		z-index: 1;
		/* padding-top: 50px; */
		transition: .3s;
	}

	.gNav.open {
		right: 0;
	}

	.gNav .gNav-menu {
		padding: 0;
		width: 100%;
		height: 100%;
		display: block;
		flex-direction: column;
		text-align: center;
		/*justify-content: center;*/
	}

	.gNav .gNav-menu li {
		width: 86%;
		padding: 15px;
		border-bottom: #525252 1px solid;
	}

	.btnhd {
		width: 80%;
		margin: 0 auto;
		padding: .9em 2em;
		border: none;
		border-bottom: 2px solid #F6A8B5;
		background-color: transparent;
		color: #e6edf3;
		font-weight: 600;
		font-size: 12px;
	}

	.logo {
		/* font-size: 40px;
	font-weight: 700; */
		width: 100%;
		margin-top: 5%;
		margin-right: 50%;
	}

	.hamburger .btn-gNav {
		position: fixed;
		top: 1%;
		right: 7%;
		/* クリッカブルエリアを広げる */
		width: 50px;
		/* 30pxから拡大 */
		height: 44px;
		/* 24pxから拡大 */
		padding: 10px;
		/* パディングを追加してタップ領域を確保 */
		z-index: 12;
		box-sizing: border-box;
		cursor: pointer;
		-webkit-transition: all 400ms;
		transition: all 400ms;
		/* タップ領域を視覚的に確認したい場合はコメントを外す */
		/* background: rgba(0, 0, 0, 0.1); */
	}

	/* ハンバーガーアイコンの線は中央に配置 */
	.hamburger .btn-gNav span {
		position: absolute;
		width: 30px;
		/* 線の長さは元のまま */
		height: 4px;
		left: 50%;
		transform: translateX(-50%);
		/* 中央寄せ */
		background: #ffffff;
		border-radius: 10px;
		-webkit-transition: all 400ms;
		transition: all 400ms;
	}

	/* 開いた状態の1番目の線 */
	.hamburger .btn-gNav.open span:nth-child(1) {
		top: 10px;
		transform: rotate(-45deg);
	}

	/* 開いた状態の2番目の線 */
	.hamburger .btn-gNav.open span:nth-child(2) {
		opacity: 0;
	}

	/* 開いた状態の3番目の線 */
	.hamburger .btn-gNav.open span:nth-child(3) {
		top: 10px;
		transform: rotate(45deg);
	}
}
</style>